import { db } from "common/config/Firebase"

const collectionParams = db.collection('params')

const updateColumnsOrderUseCase = ({ doc, columns }) => {
    const columnsOrder = {}
    columns.forEach(col => {
        columnsOrder[col.field] = col.tableData.columnOrder
    })

    collectionParams.doc(doc).set({ columnsOrder }, { merge: true })
}

export default updateColumnsOrderUseCase